import React, { useCallback, useEffect } from 'react'
import Button from '@mui/joy/Button'
import { useAuth } from '../AuthContext'
import { useNavigate, useLocation } from 'react-router-dom'
import Typography from '@mui/joy/Typography'
import GoogleIcon from '@mui/icons-material/Google'
import Box from '@mui/joy/Box'
import { Card, CardContent } from '@mui/joy'
import { useSignInWithGoogleMutation } from '../services/auth'

function GoogleAuth() {
  const { setIsAuthenticated, setToken } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const [signInWithGoogle, { isLoading, isError }] =
    useSignInWithGoogleMutation({ fixedCacheKey: 'shared-delete-reward' })

  const handleLogin = () => {
    localStorage.removeItem('adminToken')

    window.location.href =
      'https://admin-auth.gyore-soma.workers.dev/auth/login'
  }

  const handleCallback = useCallback(
    async (code: string) => {
      try {
        const response = await signInWithGoogle({ code }).unwrap()

        setIsAuthenticated(true)
        setToken(response.token)
        localStorage.setItem('adminToken', response.token)

        navigate('/')
      } catch (err) {
        console.error('Authentication error:', err)
      }
    },
    [navigate, setIsAuthenticated, setToken, signInWithGoogle],
  )

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const code = urlParams.get('code')

    if (code) {
      handleCallback(code)
    }
  }, [location, handleCallback])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height
        backgroundColor: '#f5f5f5', // Light background for contrast
      }}
    >
      <Card
        variant="outlined"
        sx={{
          width: 400,
          padding: 2,
          boxShadow: 'md',
          borderRadius: 'lg',
          textAlign: 'center',
          backgroundColor: '#fff', // White card background
        }}
      >
        <CardContent>
          <Typography level="h4" fontWeight="lg" mb={2}>
            Bejelentkezés
          </Typography>
          <Button
            variant="outlined"
            color="neutral"
            startDecorator={<GoogleIcon />}
            sx={{
              fontWeight: 'md',
              borderRadius: '8px',
              borderColor: '#747775',
              color: '#1F1F1F',
              '&:hover': {
                backgroundColor: '#F2F2F2',
              },
            }}
            onClick={handleLogin}
            disabled={isLoading}
          >
            Bejelentkezés Google fiókkal
          </Button>
          {isLoading && (
            <Typography mt={2} color="neutral">
              Bejelentkezés folyamatban...
            </Typography>
          )}
          {isError && (
            <Typography mt={2} color="danger">
              Hiba történt a bejelentkezés során.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default GoogleAuth
